module.exports = __webpack_public_path__ + "static/media/videocam-outline.ebed462f.png";